export enum MatrixType {
  FIRST = 'crossconnect',
  SECOND = 'tagging',
}
